import { IN_VP_EVENT, OUT_VP_EVENT } from "Constants/eventNames";

class ViewportObserverService {

  constructor() {
    this.observer = new IntersectionObserver((e) => this.handleIntersectionChange(e));
  }

  handleIntersectionChange(e) {
    Object.keys(e).forEach((key) => {
      const observedEl = e[key];
      const target = observedEl.target;

      if (observedEl.isIntersecting) {
        target.dispatchEvent(new CustomEvent(IN_VP_EVENT));
      } else {
        target.dispatchEvent(new CustomEvent(OUT_VP_EVENT));
      }
    });
  }

  observe(target) {
    this.observer.observe(target);
  }

  unobserve(target) {
    this.observer.unobserve(target);
  }

}

export default new ViewportObserverService();